import React, {useState} from 'react';
import moment from "moment";
import {useForm} from "react-hook-form";
import {Portlet, PortletBody} from "../../../components/Portlet";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import LoadingButton from "../../base/components/loadingButton";
import {Form, Tab, Table, Tabs} from "react-bootstrap";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import _ from "lodash";
import BlockUi from "@availity/block-ui";
import {tabsName} from "../../counterparty/components/sinkRateHawk";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute} from "../../routesConstants";
import numberFormat from "../../../helpers/numberFormat";
import Button from "react-bootstrap/Button";
import axios from "../../../helpers/axios";
import RustarParseModal from "./rustarParseModal";
import DiffRustarTab from "./diffRustarTab";

const SinkRustar = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [activeInfo, setActiveInfo] = useState()
  const start= moment().subtract(7,'d').format('DD.MM.YYYY')
  const end = moment().format('DD.MM.YYYY')
  const formController = useForm({
    start,end
  })
  const {handleSubmit,
    register,
    formState:{errors}} = formController

  const takeTable = (data) =>{
    setLoading(true)
    const {start, end, textForParse} = data
    let m;
    const parsed = [];
    const regex = /(?<orderId>\d{4,6})\s(?<company>[A-Z,a-z]+).+?(?<issueDate>\d\d\.\d\d\.\d{4})\s(?<startDate>\d\d\.\d\d\.\d{4})\s(?<endDate>\d\d\.\d\d\.\d{4})\s(?<status>[A-Z,a-z]+)\s(?<price>[\d,\.]+)\s(?<currency>(USD|EUR))/gm;
    const countryReg = /Check in date from\/to:\s+\d\d\.\d\d\.\d{4}\s+\d\d\.\d\d\.\d{4}\s+(?<country>[A-Z]+)/gm
    const country = countryReg.exec(textForParse)?.groups.country
    while ((m = regex.exec(textForParse)) !== null){
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      parsed.push({...m.groups,
        price:parseFloat(m.groups.price.replaceAll(',',''))
      });
    }
    const filteredData =_.filter(parsed, (r)=>moment(r.issueDate, 'DD.MM.YYYY').isBetween(moment(data.start, 'DD.MM.YYYY'), moment(data.end, 'DD.MM.YYYY'),"day",'[]'))
    axios.post('/api/touristServices/rustar/revise',{
      invoices:filteredData,
      start,
      end,
      country: country === 'UAE' ? 'United Arab Emirates' : _.capitalize(country)
    })
      .then(({data})=>{
        console.log('data', data)
        setData(data)
      })
      .finally(()=>setLoading(false))
  }
  return (
    <Portlet>
      <PortletBody>

        <div className={'d-flex justify-content-between align-items-center'}>
          <form onSubmit={handleSubmit(takeTable)} className={'d-flex gap-2 align-items-end mb-2'}>
            <div style={{width:200}}>
              <CustomDatePicker formController={formController}
                                label={"Дата от"}
                                value={start}
                                name={`start`}
                                rules={{required: true}}/>
            </div>
            <div style={{width:200}}>
              <CustomDatePicker formController={formController}
                                label={"Дата до"}
                                value={end}
                                name={`end`}
                                rules={{required: true}}/>
            </div>
            <Form.Control
              as="textarea"
              rows="1"
              {...register('textForParse',{required:true})}
            />
              <LoadingButton title={"Получить"}
                             disabled={loading}
                             loading={loading}/>

          </form>
          <Button variant={'primary'} onClick={()=> {
            setShow(!show)
            setActiveInfo({
              issueDate : moment().format('DD.MM.YYYY')
            })
          }}>
            Создать
          </Button>
        </div>
        <BlockUi blocking={loading}>
          {data && <Tabs defaultActiveKey="missedBookings">
            {Object.keys(data).map((key, i) => {
              return <Tab
                eventKey={key}
                key={i}
                title={<div>{tabsName[key]?.name} ({data[key].length})
                  {(tabsName[key]?.alertInfo && data[key].length > 0) &&
                    <i className="fa fa-exclamation-circle text-danger ml-2"></i>
                  }</div>}
              >
                {key === "diff" ?
                  <DiffRustarTab data={data[key]}/> :
                  <Table striped bordered hover>
                    <thead>
                    <tr>
                      <th>Индивидуальный код</th>
                      <th>Создано</th>
                      <th>Период</th>
                      <th>Сумма закупа</th>
                      {(key !== "correctBookings" && key !== "onlyOurBase") &&
                        <th></th>}
                    </tr>
                    </thead>
                    <tbody>
                    {data[key].map((order, index) => {
                      return <tr key={index}>
                        <td>
                          <div className={'d-flex justify-content-between'}>
                            <div>
                              {( key === 'correctBookings' || key === 'onlyOurBase') ?
                                <Link to={TouristServicesEditRoute + `${key === 'onlyOurBase' ?order.invoiceId.id : order.invoiceId}`}
                                      target={'_blank'}>{order.orderId}</Link> :
                                <>{order.orderId}</>}
                            </div>
                          </div>
                        </td>
                        <td>{order.issueDate}</td>
                        <td>{order.startDate} - {order.endDate}</td>
                        <td className={'text-end'}>{numberFormat(+order.price)} {order.currency}</td>
                        {(key === 'missedBookings' || key === 'unidentified') &&
                          <td style={{width:'5rem'}}>
                            <Button variant={'primary'} onClick={()=> {
                              setShow(!show)
                              setActiveInfo(order)
                            }}>
                              Создать
                            </Button>
                          </td>}
                        {key === 'canceledBookings' && <td>
                          <Link to={{
                            pathname: TouristServicesEditRoute + order.invoiceId,
                            search: `?canceled=${order.price}&id=${order.orderId}`
                          }}
                                target={'_blank'} className={'d-flex gap-2 text-danger align-items-center'}>
                            <i className="fa fa-window-close"/>
                            <div>Отменить</div>
                          </Link>
                        </td>}

                      </tr>

                    })}
                    </tbody>
                  </Table>
                }

              </Tab>
            })
            }
          </Tabs>}
          {activeInfo && <RustarParseModal orderBase={activeInfo}
                                           show={show}
                                           close={()=>{
            setShow(!show)
            setActiveInfo()
          }} />}
        </BlockUi>

      </PortletBody>
    </Portlet>
  );
};

export default SinkRustar;





